export default {
  buttons: {
    send_code: 'Lähetä kirjautumiskoodi',
  },
  placeholders: {
    mobile_number: 'Matkapuhelinnumero',
    email: 'Sähköpostiosoite',
  },
  feedback: {
    phone_number_required: 'Syötä puhelinnumerosi',
    email_required: 'Syötä sähköpostiosoitteesi',
  },
};
